/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputGetAllClientDto } from '../../models/output-get-all-client-dto';

export interface ClientManagementGetAllClientsPost$Plain$Params {
}

export function clientManagementGetAllClientsPost$Plain(http: HttpClient, rootUrl: string, params?: ClientManagementGetAllClientsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputGetAllClientDto>>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetAllClientsPost$Plain.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OutputGetAllClientDto>>;
    })
  );
}

clientManagementGetAllClientsPost$Plain.PATH = '/ClientManagement/GetAllClients';
